import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInitializedEmitterService {
  private appInitialized = new Subject<boolean>();

  markAppAsInitialized() {
    this.appInitialized.next(true);
  }

  isAppInitialized() {
    return this.appInitialized.asObservable();
  }
}
